//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'bcc-password-dialog',
  props: {
    isShow: Boolean,
    value: String | Number,
    passwordError: false,
  },
  data(){
    return {
      password: '',
      pwdTempArray: ['', '', '', '', '', ''],
    };
  },
  computed: {
    // 设置bcc支付密码链接
    setBccPasswordUrl(){
      return `${this.$store.state.WAP_HOST}pay_pwd.php?redirect_url=${encodeURIComponent(this.$store.state.WAP_HOST)}`;
    },
  },
  watch: {
    password(currentPwd){
      this.$emit('input', currentPwd);
    },

    /** 密码错误重置输入框 */
    passwordError(currentError){
      if(currentError){
        this.resetDialog();
      }
    },
  },
  methods: {
    onClose(){
      this.$emit('on-hide');
      this.resetDialog();
    },

    /** 密码输入处理 */
    onInputPwd(){
      const spot = '•';
      const pwdArr = this.password.split('');

      pwdArr.forEach((it, idx) => {
        this.pwdTempArray[idx] = spot;
      });

      if(this.password.length === 6){
        // this.$refs.bccPwdInput.blur();
        document.getElementById('bccPassword').blur();
        setTimeout(() => {
          this.$emit('on-finished');
        }, 100);
      }
    },

    /** 重置相关内容 */
    resetDialog(){
      this.password = '';
      this.pwdTempArray = ['', '', '', '', '', ''];
      this.$emit('on-reset-password-error');  // 重置支付密码错误状态
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/BccPasswordDialog/BccPasswordDialog.vue